import { useState, useEffect } from 'react';
import SubPageHeader from '../SubPageHeader';
import { toast } from 'sonner';

const FONT_SIZES = [
  { key: 'sm', label: 'صغير', size: '14px', px: 14 },
  { key: 'md', label: 'عادي', size: '16px', px: 16 },
  { key: 'lg', label: 'كبير', size: '18px', px: 18 },
  { key: 'xl', label: 'كبير جداً', size: '22px', px: 22 },
];

const THEMES = [
  { key: 'light', label: 'فاتح', icon: '☀️' },
  { key: 'dark', label: 'داكن', icon: '🌙' },
  { key: 'auto', label: 'تلقائي', icon: '🔄' },
];

export default function AppearanceSection({ onBack }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('app_theme') || 'light');
  const [fontSize, setFontSize] = useState(() => localStorage.getItem('app_font_size') || 'md');
  const [numberFormat, setNumberFormat] = useState(() => localStorage.getItem('app_number_format') || 'western');
  const [currency, setCurrency] = useState(() => localStorage.getItem('app_currency_display') || 'EGP');

  const applyTheme = (t) => {
    setTheme(t);
    localStorage.setItem('app_theme', t);
    if (t === 'dark') document.documentElement.classList.add('dark');
    else if (t === 'light') document.documentElement.classList.remove('dark');
    else {
      const sys = window.matchMedia('(prefers-color-scheme: dark)').matches;
      document.documentElement.classList.toggle('dark', sys);
    }
    toast.success('تم تطبيق الثيم');
  };

  const applyFontSize = (k) => {
    setFontSize(k);
    localStorage.setItem('app_font_size', k);
    const px = FONT_SIZES.find(f => f.key === k)?.px || 16;
    document.documentElement.style.fontSize = `${px}px`;
    toast.success('تم تغيير حجم الخط');
  };

  return (
    <div className="flex flex-col min-h-full" dir="rtl">
      <SubPageHeader title="المظهر والتخصيص" onBack={onBack} />
      <div className="p-4 space-y-4">

        {/* Theme */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">🎨 الثيم</p>
          <div className="grid grid-cols-3 gap-2">
            {THEMES.map(t => (
              <button key={t.key} onClick={() => applyTheme(t.key)}
                className={`flex flex-col items-center gap-2 p-3 rounded-xl border-2 transition-all ${theme === t.key ? 'border-primary bg-primary/5' : 'border-border bg-card'}`}>
                <span className="text-2xl">{t.icon}</span>
                <span className="text-xs font-semibold">{t.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Font Size */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">🔤 حجم الخط</p>
          <div className="grid grid-cols-2 gap-2">
            {FONT_SIZES.map(f => (
              <button key={f.key} onClick={() => applyFontSize(f.key)}
                className={`flex items-center justify-between p-3 rounded-xl border-2 transition-all ${fontSize === f.key ? 'border-primary bg-primary/5' : 'border-border'}`}>
                <span className={`font-bold ${fontSize === f.key ? 'text-primary' : 'text-foreground'}`} style={{ fontSize: f.size }}>أ</span>
                <div className="text-right">
                  <p className="text-sm font-semibold text-foreground">{f.label}</p>
                  <p className="text-xs text-muted-foreground">{f.size}</p>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Number Format */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">🔢 تنسيق الأرقام</p>
          <div className="grid grid-cols-2 gap-2">
            {[
              { key: 'western', label: 'غربي', example: '1,234.56' },
              { key: 'arabic', label: 'عربي', example: '١٬٢٣٤٫٥٦' },
            ].map(n => (
              <button key={n.key} onClick={() => { setNumberFormat(n.key); localStorage.setItem('app_number_format', n.key); toast.success('تم الحفظ'); }}
                className={`p-3 rounded-xl border-2 transition-all text-center ${numberFormat === n.key ? 'border-primary bg-primary/5' : 'border-border'}`}>
                <p className="text-sm font-bold text-foreground">{n.label}</p>
                <p className="text-xs text-muted-foreground mt-1 font-mono">{n.example}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Currency */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">💱 عرض العملة</p>
          <div className="grid grid-cols-3 gap-2">
            {['EGP', 'ج.م', 'L.E'].map(c => (
              <button key={c} onClick={() => { setCurrency(c); localStorage.setItem('app_currency_display', c); toast.success('تم الحفظ'); }}
                className={`p-3 rounded-xl border-2 transition-all text-center ${currency === c ? 'border-primary bg-primary/5' : 'border-border'}`}>
                <span className="font-bold text-sm">{c}</span>
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}